var EsecsiceConst = {};

EsecsiceConst.execsice_index = {
    endless : 1,  // 无尽试炼
    stonedungeon : 2, // 日常副本
    heroexpedit : 3, // 英雄远征
    honourfane : 4, // 荣耀神殿
};

module.exports = EsecsiceConst;